
const tryFindQueryParameter = key => {
  const locationSearch = window.location.search;
  if (!locationSearch) {
    return null;
  }
  const urlSearchParams = new URLSearchParams(locationSearch);
  return urlSearchParams.get(key) || null;
};

const queryParameterUtils = {
  tryFindQueryParameter,
};
export default queryParameterUtils;
